import { setItem, getItem, removeItem } from '@/utils/storage/sessionStorageHelper'

import { SESSION_STORAGE_KEYS } from '@/constant/storage'

/**
 * 儲存當前路徑用於之後的重定向
 * @param includeParams 是否包含查詢參數
 * @param includeHash 是否包含hash片段
 */
const saveCurrentPath = (includeParams = false, includeHash = false): void => {
  let currentUrl = window.location.pathname

  if (includeParams && window.location.search) {
    currentUrl += window.location.search
  }

  if (includeHash && window.location.hash) {
    currentUrl += window.location.hash
  }

  setItem(SESSION_STORAGE_KEYS.REDIRECT_PATH, currentUrl)
}

/**
 * 獲取儲存的重定向路徑
 * @returns 儲存的路徑，如果沒有則返回null
 */
const getSavedRedirectPath = (): string | null => {
  const path = getItem(SESSION_STORAGE_KEYS.REDIRECT_PATH)

  // 僅接受站內相對路徑：// 與 /\ 開頭會被瀏覽器視為跨網域網址，直接導向會形成 open redirect
  if (path && path.startsWith('/') && !path.startsWith('//') && !path.startsWith('/\\')) {
    return path
  }

  return null
}

/**
 * 清除儲存的重定向路徑
 */
const clearRedirectPath = (): void => {
  removeItem(SESSION_STORAGE_KEYS.REDIRECT_PATH)
}

/**
 * 重定向到儲存的路徑，如果沒有則重定向到預設路徑
 * @param defaultPath 預設路徑，如果沒有保存的路徑則使用此路徑
 */
const redirectToSavedPath = (defaultPath = '/'): void => {
  const redirectPath = getSavedRedirectPath()

  if (redirectPath) {
    clearRedirectPath()
    window.location.href = redirectPath
  } else {
    window.location.href = defaultPath
  }
}

export { saveCurrentPath, getSavedRedirectPath, clearRedirectPath, redirectToSavedPath }
